import React from "react";
import { Container, Row, Col } from "reactstrap";
import Helmet from "../components/Helmet/Helmet";
import CommonSection from "../components/UI/CommonSection";
import CarItem from "../components/UI/CarItem";
import carData from "../assets/data/carData";
// import img1 from "../assets/all-images/scholaship.png";
import img1 from "../assets/all-images/outsource.jpeg";
import img2 from "../assets/all-images/recruitment.jpeg";
import img3 from "../assets/all-images/scolarship.jpeg";
import img4 from "../assets/all-images/pooling.png";


const CarListing = () => {
  return (
    <Helmet title="Cars">
      <CommonSection title="Our Services" />

      <section>
        <Container>
        <Row>
                    <Col lg="6" md="8" sm="15" className="mt-5">
                      <h4 className="section__title  ">
                      Outsourcing Services
                      </h4>
          
                      <p className="section_description mt-4 ">we are not just an employee allocation service, we are a 
                        comprehensive one-stop service center for all your HR needs</p>
                        <p className="section_description mt-4 ">involve delegating specific human resource functions and tasks to third-party service providers. 
                          This can help businesses streamline HR operations, reduce costs, and focus on core competencies.</p>
                    </Col>
                    
                    <Col lg="6" md="6" sm="10" className="become__driver-img pb-5 pl-5">
                      <img src={img1} alt="" className="w-60 h-70" />
                    </Col>
                  </Row>
                  <br />

                  <Row>
                  <Col lg="6" md="6" sm="10" className="become__driver-img pb-5 pl-5">
                      <img src={img2} alt="" className="w-60 h-70" />
                    </Col>

                    <Col lg="6" md="8" sm="15" className="mt-5">
                      <h4 className="section__title  ">
                      Recruitment services
                      </h4>
          
                      <p className="section_description mt-4 ">we are not just an employee allocation service, 
                        we are a comprehensive one-stop service center for all your HR needs</p>
                        <p className="section_description mt-4 ">involve delegating specific human resource functions and tasks to 
                          third-party service providers. This can help businesses streamline HR operations, reduce costs, and focus on core competencies.</p>
                    </Col>
                  
                  </Row>
                  <br />
          <Row>
                    <Col lg="6" md="8" sm="15" className="mt-5">
                      <h4 className="section__title  ">
                      Scholarships Applications
                      </h4>
          
                      <p className="section_description mt-4 ">we are not just an employee allocation service, 
                        we are a comprehensive one-stop service center for all your HR needs</p>
                        <p className="section_description mt-4 ">involve delegating specific human resource functions and 
                          tasks to third-party service providers.This can help businesses streamline HR operations, reduce costs,
                            and focus on core competencies.</p>
                    </Col>
                    <Col lg="6" md="6" sm="10" className="become__driver-img pb-5 pl-5">
                      <img src={img3} alt="" className="w-60 h-70" />
                    </Col>
                  </Row>

                  <br />

                  <Row>
                  <Col lg="6" md="6" sm="10" className="become__driver-img pb-5 pl-5">
                      <img src={img4} alt="" className="w-60 h-70" />
                    </Col>

                    <Col lg="6" md="8" sm="15" className="mt-5">
                      <h4 className="section__title  ">
                      Human resourcing pooling
                      </h4>
          
                      <p className="section_description mt-4 ">we are not just an employee allocation service,
                         we are a comprehensive one-stop service center for all your HR needs</p>
                        <p className="section_description mt-4 ">involve delegating specific human resource functions and tasks to third-party service providers.
                           This can help businesses streamline HR operations, reduce costs, and focus on core competencies.</p>
                    </Col>
                  
                  </Row>
                  <br />
        </Container>
      </section>
    </Helmet>
  );
};

export default CarListing;